import React, { useState, useEffect } from 'react'; // Import useState and useEffect

export default function AiInteractionModals({
  showAiModalForProjectId, // ID of project for AI prompt modal, or null
  // aiRequestText, // Removed prop - will be managed locally
  // onAiRequestTextChange, // Removed prop - will be managed locally
  onCloseAiModal,
  onSubmitAiRequest, // Function to trigger AI request (will receive text as argument)
  showLogsModalConfig, // { projectId, interactionId } or null
  logsLoading,
  currentLogs,
  onCloseLogsModal,
  initialAiContent = ''
}) {
  // Local state for the AI prompt text
  const [localAiRequestText, setLocalAiRequestText] = useState('');

  // Effect to reset local state when the modal is opened for a new project
  // or when the modal is closed.
  useEffect(() => {
    if (showAiModalForProjectId !== null) {
      // Optionally pre-fill with a value from parent if needed, otherwise start empty
      setLocalAiRequestText(initialAiContent || ''); // Reset text when modal opens
    } else {
      setLocalAiRequestText(''); // Also clear when modal closes
    }
  }, [showAiModalForProjectId, initialAiContent]);


  // --- AI Prompt Modal ---
  const renderAiPromptModal = () => {
    // Return null entirely if the modal should not be shown
    if (showAiModalForProjectId === null) return null;

    // Otherwise, render the overlay with the 'visible' class
    return (
      <div className="popup-overlay visible" onClick={onCloseAiModal}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h3>Generuj modyfikacje AI</h3>
              {/* Add the close button back here */}
              <button onClick={onCloseAiModal} className="popup-close-btn">&times;</button>
            </div>
            <div className="popup-body">
              <p>Wpisz treść polecenia dla AI, aby zmodyfikować projekt:</p>
              <textarea
                rows={5}
                value={localAiRequestText} // Use local state value
                onChange={(e) => setLocalAiRequestText(e.target.value)} // Update local state
                placeholder="np. Zmień czcionkę imion na bardziej elegancką, dodaj tekst 'Dziękujemy' na dole strony..."
                style={{ width: '100%', minHeight: '80px', marginBottom: '10px' }}
              />
            </div>
            <div className="popup-footer">
              <button
                // Pass projectId and the local text state to the submit handler
                onClick={() => onSubmitAiRequest(showAiModalForProjectId, localAiRequestText)}
                className="popup-btn popup-btn-confirm"
                disabled={!localAiRequestText.trim()} // Disable based on local state
              >
                Wyślij do AI
              </button>
              <button onClick={onCloseAiModal} className="popup-btn popup-btn-cancel">
                Anuluj
              </button>
            </div>
          </div>
      </div> // Closing tag for popup-overlay moved inside conditional rendering
    );
  };

  // --- AI Logs Modal ---
  const renderAiLogsModal = () => {
    // Return null entirely if the modal should not be shown
    if (showLogsModalConfig === null) return null;

    // Otherwise, render the overlay with the 'visible' class
    return (
      <div className="popup-overlay visible" onClick={onCloseLogsModal}>
          <div className="popup-content popup-logs" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h3>Logi interakcji AI</h3>
              {/* Corrected close button placement */}
              <button onClick={onCloseLogsModal} className="popup-close-btn">&times;</button>
            </div>
            <div className="popup-body">
              {logsLoading ? (
                <p>Ładowanie logów...</p>
              ) : (
                <pre className="ai-logs-content">
                  {currentLogs || "Brak logów do wyświetlenia."}
                </pre>
              )}
            </div>
            <div className="popup-footer">
              <button onClick={onCloseLogsModal} className="popup-btn popup-btn-confirm">
                Zamknij
              </button>
            </div>
          </div>
      </div> // Closing tag for popup-overlay moved inside conditional rendering
    );
  };

  return (
    <>
      {renderAiPromptModal()}
      {renderAiLogsModal()}
    </>
  );
}
